import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useMemo } from 'react';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useActionsCollapserContext } from '../ActionsCollapser/ActionsCollapserProvider';
import { deepMerge } from '../../utils/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
const GRID_BREAKPOINT_SMALL = '544px';
const justifyContentMap = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'end',
  start: 'start'
};
export const FlexContainer = styled.div.withConfig({
  displayName: "ButtonWrapper__FlexContainer"
})(({
  $alignItems,
  $justifyContent,
  $rowGap,
  $columnGap,
  $styleOverrides
}) => {
  return deepMerge({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: $alignItems,
    flexGrow: 1,
    justifyContent: justifyContentMap[$justifyContent],
    width: 'auto',
    maxWidth: 'none',
    marginLeft: `-${$columnGap}px`,
    marginTop: `-${$rowGap}px`,
    // Higher specificity to override Button's adjacent sibling auto-spacing
    '&&&&& > *': {
      marginLeft: `${$columnGap}px`,
      marginTop: `${$rowGap}px`
    },
    [`@media only screen and (max-width: ${GRID_BREAKPOINT_SMALL})`]: {
      flexGrow: 1
    }
  }, $styleOverrides);
});
const StyledDiv = styled.div.withConfig({
  displayName: "ButtonWrapper__StyledDiv"
})(({
  $cssStyles
}) => Object.assign({}, $cssStyles));
export const ButtonWrapper = _ref => {
  let {
      children,
      alignItems = 'center',
      justify = 'start',
      horizontalGap = 12,
      verticalGap = 6,
      flexRef,
      innerFlexContainerStyles = {},
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, ["children", "alignItems", "justify", "horizontalGap", "verticalGap", "flexRef", "innerFlexContainerStyles", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const actionsCollapserContext = useActionsCollapserContext();
  const innerFlexContainerCssStyles = useMapTokenPropsToCSS(innerFlexContainerStyles);
  const sharedStyleOverrides = useMemo(() => {
    var _actionsCollapserCont;
    return deepMerge((_actionsCollapserCont = actionsCollapserContext === null || actionsCollapserContext === void 0 ? void 0 : actionsCollapserContext.buttonWrapperStyleOverrides) !== null && _actionsCollapserCont !== void 0 ? _actionsCollapserCont : {}, innerFlexContainerCssStyles);
  }, [actionsCollapserContext === null || actionsCollapserContext === void 0 ? void 0 : actionsCollapserContext.buttonWrapperStyleOverrides, innerFlexContainerCssStyles]);
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({
    $cssStyles: cssStyles
  }, domProps, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'ButtonWrapper',
    children: /*#__PURE__*/_jsx(FlexContainer, {
      $alignItems: alignItems,
      $justifyContent: justify,
      $rowGap: verticalGap,
      $columnGap: horizontalGap,
      $styleOverrides: sharedStyleOverrides,
      ref: flexRef,
      children: children
    })
  }));
};
ButtonWrapper.displayName = 'ButtonWrapper';